import { useRef } from "react";
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

// Contact form 
const Contact = () => {
    const form = useRef();
    
    const submitHandler = e => {
        e.preventDefault();
        
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID , process.env.REACT_APP_TEMPLATE_ID , form.current , process.env.REACT_APP_PUBLIC_KEY)
        .then(res => {
            if(res.status === 200) {
                toast.success("Message sent successfully" , {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }
            else {
                toast.error("Unable to send message" , {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }
        })
        .catch(err => {
            console.log(err);
        })

        form.current.reset();
    }

    return (
        <div className="m-8 text-xl text-black">
            <form ref={form} className="m-auto flex flex-col space-y-4 sm:w-96 w-full" onSubmit={submitHandler}>
                    <input 
                        placeholder="Full name"
                        type="text"
                        name="name"
                        className="p-2 rounded"
                        required
                    />
                    <input 
                        placeholder="Email"
                        type="email"
                        name="email"
                        className="p-2 rounded"
                        required
                    />
                    <textarea 
                        placeholder="Message"
                        type="text"
                        name="message"
                        className="p-2 h-40 rounded"
                        required
                    />
                <button 
                    type="submit"
                    value="Send"
                    className="p-2 text-white bg-purple-800 rounded"
                >Send</button>
            </form>
        </div>
    );
}

export default Contact;